import { ProductsValidationResult } from "ts/app/productsBulkUpload";

export enum ProductImportProgress {
  FILE_UPLOAD = 0,
  REVIEW,
}

export enum ProductCsvUploadProgress {
  TEMPLATE_DOWNLOAD = 0,
  CSV_UPLOAD,
}

export type ProductsCsvFileStatus =
  | "no-file-uploaded"
  | "valid-csv"
  | "missing-required-fields"
  | "invalid-colour"
  | "invalid-category"
  | "unsupported-file-format";

export type ProductImportStatus = {
  productImportProgress: ProductImportProgress;
  csvUploadProgress: ProductCsvUploadProgress;
  productsCsvFileStatus: ProductsCsvFileStatus;
  productsValidationResult: ProductsValidationResult | null;
};
